/**
 * Svg
 */
import Config from "./Config";
import Util from "./Util";

const win = window as any;
const Svg = {
  get() {
    const staticUrl = Util.getStaticUrl();
    if ( !Config.isSvgLoaded) {
      jQuery.get(`${staticUrl}/fonts/svg/community/nc-symbols.svg`, function(data) {
        const div = document.createElement("div");
        div.innerHTML = new XMLSerializer().serializeToString(data.documentElement);
        document.body.insertBefore(div, document.body.childNodes[0]);
      });
      Config.isSvgLoaded = true;
    }
  },
  getIcon(symbol: any) {
    return `<svg class="fe-svg fe-svg-${symbol}"><use xlink:href="#fe-svg-${symbol}"></use></svg>`;
  },
};

export default Svg;
